import React from "react";
import { connect } from "react-redux";
import SelectV2 from "../../../view/SelectV2";
import * as storeService from "../addRuleStoreService";

const severity = [
    "Low",
    "Medium",
    "High"
]

function SeverityDropdown({ rule, disabled }) {
    const severityOptions = severity.map((name) => ({ value: name, label: name }));

    const onChange = (value) => {
        storeService.changeRule({ ...rule, severity: value })
    }

    return (
        <div className="addrules-form-group-v2">
            <label className="addrules-form-label-v2">Severity</label>
            <SelectV2
                inputId="rule-severity"
                className="addrules-form-select-v2"
                value={rule.severity}
                onChange={onChange}
                options={severityOptions}
                isDisabled={disabled}
            />
        </div>
    )

}

function mapStateToProps(state) {
    return {
        rule: state.addRulesPage.rule || {}
    }
}

export default connect(mapStateToProps)(SeverityDropdown);
